"use client"

import React, { HTMLAttributes, ReactNode, useEffect, useState } from "react"
import Cookies from "js-cookie"
import { XIcon } from "lucide-react"

import { UB_INFO_BAR_COOKIE_NAME } from "@/lib/info-bar-cookies"
import { cn } from "@/lib/utils"

export default function InfoBarClient(props: {
  timeoutInDays: number
  children: HTMLAttributes<HTMLDivElement>["children"]
  contentHash: string
}) {
  const [infobarDeactivated, setInfobarDeactivated] = useState<boolean>(true)
  const [transitionToHiding, setTransitionToHiding] = useState(false)

  const hideInfoBar = () => {
    setTransitionToHiding(true)
    setTimeout(() => {
      setInfobarDeactivated(true)
      Cookies.set(UB_INFO_BAR_COOKIE_NAME, props.contentHash, {
        expires: props.timeoutInDays,
      })
    }, 150)
  }

  useEffect(() => {
    const exitPopupCookieValue = Cookies.get(UB_INFO_BAR_COOKIE_NAME)
    const ecShownFromCookie = exitPopupCookieValue == props.contentHash
    if (exitPopupCookieValue && exitPopupCookieValue != props.contentHash) {
      // old infobar state => Delete cookie and show new infobar
      Cookies.remove(UB_INFO_BAR_COOKIE_NAME)
    }
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setInfobarDeactivated(ecShownFromCookie)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {!infobarDeactivated && (
        <div
          className={cn(
            "fixed inset-x-0 bottom-0 z-200 flex h-12 w-screen overflow-hidden bg-amber-400 px-5 transition-all",
            {
              "h-0": transitionToHiding,
            }
          )}
        >
          <div className="flex grow flex-col items-center justify-center">{props.children}</div>
          <XIcon onClick={hideInfoBar} className="h-full cursor-pointer"></XIcon>
        </div>
      )}
    </>
  )
}
